import { environment as prod } from './environment.prod';

export const environment = {
  ...prod,
  production: false,
  useSmartlook: false,
  urlApp: 'https://avatar.pyjam.com',
  urlBackEnd: 'https://dev.pyjam.com',
  urlBackEndApi: 'https://dev.pyjam.com/api',
  socketConfig: {
    url: 'https://dev.pyjam.com',
    options: {autoConnect: false, transports: ['websocket', 'polling'], tryAllTransports: true},
  },
  recordServer: 'https://test.newageit.ru',
  mediaServers: [
    {name: 'Server FIN', socketUrl: 'wss://test.newageit.ru/ping', serverUrl: 'https://test.newageit.ru'},
    {name: 'Server FIN_COPY', socketUrl: 'wss://test.newageit.ru/ping', serverUrl: 'https://test.newageit.ru'},
  ],
  apple: {
    ...prod.apple,
    redirectUrl: 'https://dev.pyjam.com/api/auth/webhook',
  },
  paypal: {
    clientId: 'AVOQNdd6IdfGojeYGvTUmpSZvLXZ57fIbfN_rdeSs2D8hmNMSG-GSOYZc4b-t9Dn8-tg5haPaV_uSTFC',
  },
};
